module.exports = __webpack_public_path__ + "static/best-82319e6ae8b108275adc6a4b9e3b9dfb.svg";